import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAirfranceComponent } from './simple-icons-airfrance.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAirfranceComponent ],
    exports:      [ SimpleIconsAirfranceComponent ],
    bootstrap:    []
})
export class SimpleIconsAirfranceModule {}
